__turbopack_context__.v({
  "container": "gapminder-module-scss-module__BLOhfa__container",
  "loader-container": "gapminder-module-scss-module__BLOhfa__loader-container",
  "placeholder": "gapminder-module-scss-module__BLOhfa__placeholder",
});
